module.exports = __webpack_public_path__ + "static/media/basket-icon.08bd29da.svg";